module.exports = __webpack_public_path__ + "static/media/FeelBetterText.32c599e8.png";